import * as React from 'react';
import { Layout } from 'antd';

import { DocLayout } from '../../layouts/DocLayout';
import { Ac2ServiceDoc } from '../../containers/Ac2ServiceDoc';

export class Ac2ServiceDocPage extends React.Component {
  render() {
    return (
      <DocLayout>
        <Layout className="doc-root">
            <Ac2ServiceDoc/>
        </Layout>
      </DocLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Ac2ServiceDocPage/index.tsx